import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
    selector: 'app-picket-edit-dialog',
    templateUrl: 'picket-editor.component.html',
    styleUrls: ['./picket-editor.component.scss']
})
export class PicketEditorComponent {

    currentInfo: {
        currentPost: string,
        currentLabelPos: string
    };

    @ViewChild('editorElement') editorElement: ElementRef;
    @ViewChild('sizeCalculationDiv') sizeCalculationDiv: ElementRef;

    constructor(
        private dialogRef: MatDialogRef<PicketEditorComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) {
        this.currentInfo = {
            currentPost: "",
            currentLabelPos: ""
        };
        this.postTypes.forEach(pt => {
            if (pt === data.postType) {
                this.currentInfo.currentPost = pt;
            }
        });
        this.labelPositions.forEach(lp => {
            if (lp === data.labelPosition) {
                this.currentInfo.currentLabelPos = lp;
            }
        });
    }

    postTypes: string[] = [
        "TP", "IN", "INS", "TT", "TTS", "QC", "QCS", "PK", "PKS", "C", "SC", "45", "45B",
        "B", "PKB", "E", "CST", "CE", "QCT", "CSB", "NSP"
    ];

    labelPositions: string[] = [
        "Center", "Above", "Left Side", "Right Side", "Below"
    ];

    async apply() {
        const result = {
            postType: this.currentInfo.currentPost,
            labelPosition: this.currentInfo.currentLabelPos
        };
        this.dialogRef.close(result);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/ng-components/picket-editor/picket-editor.component.ts